import { render, staticRenderFns } from "./myProfileNavDialog.vue?vue&type=template&id=186ff1fe&scoped=true"
import script from "./myProfileNavDialog.vue?vue&type=script&lang=js"
export * from "./myProfileNavDialog.vue?vue&type=script&lang=js"
import style0 from "./myProfileNavDialog.vue?vue&type=style&index=0&id=186ff1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ff1fe",
  null
  
)

export default component.exports